
const generateSld = (layerData, styleType) => {

    let _layerData = layerData;
    let rules = _layerData.style.breaks.map(_b=>{
        
        // <Name>${_b.name}</Name>
        // <Title>Greater Than ${_b.value}</Title>
        if(styleType==='range')
            return `<Rule><ogc:Filter><ogc:PropertyIsGreaterThan><ogc:PropertyName>${_layerData.fieldName}</ogc:PropertyName><ogc:Literal>${_b.values[0]}</ogc:Literal></ogc:PropertyIsGreaterThan></ogc:Filter><PolygonSymbolizer><Fill><CssParameter name="fill">${_b.color}</CssParameter><CssParameter name="fill-opacity">${_layerData.style.opacity}</CssParameter></Fill></PolygonSymbolizer></Rule>`;
        else
        return `<Rule><ogc:Filter><ogc:PropertyIsEqualTo><ogc:PropertyName>${_layerData.fieldName}</ogc:PropertyName><ogc:Literal>${escape(_b.values[0])}</ogc:Literal></ogc:PropertyIsEqualTo></ogc:Filter><PolygonSymbolizer><Fill><CssParameter name="fill">${_b.color}</CssParameter><CssParameter name="fill-opacity">${_layerData.style.opacity}</CssParameter></Fill></PolygonSymbolizer></Rule>`
    }).join('')

    return `<?xml version="1.0" encoding="ISO-8859-1"?><StyledLayerDescriptor version="1.0.0" xsi:schemaLocation="http://www.opengis.net/sld StyledLayerDescriptor.xsd" xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><NamedLayer><Name>allum_project:${_layerData.name}</Name><UserStyle><Title>${_layerData.name}</Title><FeatureTypeStyle>${rules}</FeatureTypeStyle></UserStyle></NamedLayer></StyledLayerDescriptor>`;
}


export {
    generateSld
}